import { Directive, ElementRef, OnInit, Input, OnDestroy } from '@angular/core';

export interface DomWatchOptions {
  subtree?: boolean;
  childList?: boolean;
  attributes?: boolean;
  attributeFilter?: string[];
  attributeOldValue?: boolean;
  characterData?: boolean;
  characterDataOldValue?: boolean;
}

@Directive({
  selector: '[domWatch]'
})
export class DomWatchDirective implements OnInit, OnDestroy {
  @Input() domWatch: DomWatchOptions;
  private observer;

  constructor(private elRef: ElementRef) { }
  
  ngOnInit() {
    const element = this.elRef.nativeElement;
    this.observer = new MutationObserver(list => {
      const event = new CustomEvent('dom-mutation', { detail: list, bubbles: true });
      element.dispatchEvent(event);
    });
    this.observer.observe(element, this.domWatch);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

}
